// Companion/blocks/ArticleBlock.tsx
import { ArticleBlockBody } from './bodies/ArticleBlockBody/ArticleBlockBody';
import type { ChatArticleBlockPayload } from '@/types/chatBlocks';

/**
 * An article served into the thread. The ported `ArticleBlockBody` fetches the
 * real article by id or slug and renders the first section with a "Read Full
 * Article" expander — it never renders a retrieved snippet, which is why the
 * payload carries an id rather than prose.
 *
 * `sectionId` stays on the payload for protocol compatibility; the in-thread
 * body always starts at the top of the article, as it does today.
 */
const ArticleBlock = ({ payload }: { payload: ChatArticleBlockPayload }) => (
  <div className="companion-article-preview">
    <ArticleBlockBody item={{ articleIdOrSlug: payload.articleId }} />
  </div>
);

export default ArticleBlock;
